<button (click)="copyLatLng()" *ngIf="property?.latitude != null && property?.longitude != null"
    class="btn btn-white copy_btn" placement="top" ngbTooltip="Copy Coordinates" #tooltip="ngbTooltip"
    (hidden)="openTooltipIfShouldOpenWhenHidden()"><i class='bx bx-clipboard'></i> {{'property_search.copy_to_clipboard' | translate}}</button>
<div id="property-map" style="height: 100%" #map>
</div>